export const focusClasses =
  'focus:ring-primary-light focus:ring-4 focus:ring-offset-0 focus:outline-none'

export const focusInputClasses =
  'appearance-none focus:ring-primary-light focus-visible:ring-4 focus:ring-4 focus:ring-offset-0 focus:outline-none focus:border-slate-600 focus:placeholder-white'
